import amyPic from "@/public/images/artists/amy.png";
import { Artist } from "@/types/types";

export const amy = {
  id: "170",
  name: "Amy",
  image: amyPic,
  description: `Amy's voice balances gravelly timbres with surprising warmth and emotional depth, comfortably rooted in her lower and mid registers where a natural, raspy edge has developed. Her mid-range showcases the most texture, with a distinct graininess that adds character and grit. In higher notes, she introduces a relaxed, bluesy vibrato that retains her tonal warmth, while skillfully integrating vocal fry effects to heighten the emotional intensity of her performances.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Famy-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Rock", "Blues", "Punk", "Gritty", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 56,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
